import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { AppState } from '../../../app/store/rootReducers';
import { getLabelsByLanguage, isAdditionalProducts, getImageSrc } from '../../../utilites/util';
import LogoutFromTnAccountContainer from '../../../auth/LogoutFromTnAccount';
import Config from '../../../config/config';
import useOutsideClick from '../../../hooks/useOutsideClick';
import SendToTnAccountContainer from '../../../auth/SendToTnAccount';
import account from '../../assets/images/account.png';
import './scss/informationBar.scss';

const InformationBar: React.FC = () => {
  const detailsRef = React.createRef<HTMLDetailsElement>();
  useOutsideClick(detailsRef);
  const user = useSelector((state: AppState) => state.session.user);
  const basketItems = useSelector((state: AppState) => state.manhattanOrder.order.basket.items[0].items);
  const shouldRedirectUser = useSelector((state: AppState) => state.session.redirectUser);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [shouldTriggerRedirect, setShouldTriggerRedirect] = useState(false);

  const isBackgroundGray = Boolean(basketItems.length) || isAdditionalProducts();

  const { welcome, tnAccountSettings, logout, problemInCheckout, account: login } = getLabelsByLanguage();
  const buttonText = user.firstName.trim() ? `${user.firstName} ${user.lastName}` : welcome;

  const openDropdown = () => {
    setDropdownVisible((visible) => !visible);
  };

  const redirectToYettelAccount = (): void => {
    setShouldTriggerRedirect(true);
  };

  useEffect(() => {
    if (shouldRedirectUser) {
      setShouldTriggerRedirect(true);
    }
  }, [shouldRedirectUser]);

  return (
    <div className={classNames(isBackgroundGray && 'bg-yettel-background-grey')} data-testid="information-bar">
      <div className="row header-without-navigation m-auto pb-1 pe-2 ps-2 border-bottom lime-background justify-content-between align-items-center">
        <div className="col-3 col-lg-4 col-md-3 col-sm-3 m-0 p-0 d-flex justify-content-between align-items-center">
          <a className="logo-link yettel-bold-font ps-4" href="https://www.yettel.rs">
            <span>Yettel.</span>
          </a>
        </div>
        <div className="no-mobile col-9 col-lg-3 col-md-4 col-sm-4 d-flex justify-content-end align-items-center">
          <div className="header-without-navigation__customer-service yettel-font pb-1 d-flex align-items-center me-3">
            <span className="help-text hide-mobile">{problemInCheckout}</span>
            <div className="yettel-ecosystem-menu me-2">
              <details ref={detailsRef} data-popover="down">
                <summary className="d-block pe-1 pt-1 p-0">
                  <div className="ytl-icon-container"></div>
                  <img className="icon" width={32} height={32} alt="need-help?" src={getImageSrc('', 'help', 'png')} />
                </summary>
                <div className="ytl-popover-menu-list">
                  <a href="mailto:webshop@yettel.rs" className="ytl-menu-item">
                    <div className="ytl-menu-item-text">
                      <p>webshop@yettel.rs</p>
                    </div>
                  </a>
                  <a href="tel:063 9000" className="ytl-menu-item">
                    <div className="ytl-menu-item-text">
                      <p>0639000</p>
                    </div>
                  </a>
                </div>
              </details>
            </div>
          </div>
          <button onClick={openDropdown} type="button" className="btn login-link btn-blue-yettel--alt yettel-font">
            <p className="m-0 white-space">
              {buttonText}
              <img className="d-inline-block ms-2" width="32" src={user.avatarUrl ?? account} alt="account" />
            </p>
          </button>
          <div className="mobile-icon me-3" onClick={openDropdown}>
            <img className="d-inline-block" width="32" src={user.avatarUrl ?? account} alt="account" />
          </div>
        </div>
      </div>

      {dropdownVisible && (
        <div className="header-without-navigation__submenu d-flex justify-content-end">
          <div className="header-without-navigation__submenu_item yettel-font">
            <a href={Config.tnAccountDomain} className="yettel-link text-18">
              {tnAccountSettings}
            </a>
          </div>
          <div className="header-without-navigation__submenu_item yettel-font yettel-link text-18">
            {user.isLoggedIn ? (
              <LogoutFromTnAccountContainer>{logout}</LogoutFromTnAccountContainer>
            ) : (
              <div onClick={() => redirectToYettelAccount()} className="d-flex">
                {login}
                <SendToTnAccountContainer
                  from={window.location.href}
                  isTextVisible={false}
                  triggerRedirect={shouldTriggerRedirect}
                  isIconWhite={false}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InformationBar;
